import { render, staticRenderFns } from "./QaListItemNormalActions.vue?vue&type=template&id=546b40d6&scoped=true&"
import script from "./QaListItemNormalActions.vue?vue&type=script&lang=js&"
export * from "./QaListItemNormalActions.vue?vue&type=script&lang=js&"
import style0 from "./QaListItemNormalActions.vue?vue&type=style&index=0&id=546b40d6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "546b40d6",
  null
  
)

export default component.exports